const GoogleAdSmall3 = () => {
  return (
    <>
      <div className="rbt-callto-action rbt-cta-default style-4 bg-gradient-3 mt--20">
        <a href="https://www.tkqlhce.com/click-101154220-15255255" target="_top">Sign up today to receive $350 in free credits and free usage of 20+ products on Google Cloud.</a><img src="https://www.ftjcfx.com/image-101154220-15255255" width="1" height="1" border="0" />
      </div>
    </>
  );
};

export default GoogleAdSmall3;
